// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__pOEjI","local":"styles_local___1XKC","remote":"styles_remote__VhDCr","wait":"styles_wait__2-26d"};